import React from 'react';
export function FinalCTASection() {
  return <section className="w-full py-24 md:py-32 px-6 bg-dark text-center relative overflow-hidden" data-id="element-66">
      {/* Subtle background glow */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-full max-w-3xl h-full bg-warmgold/5 blur-[120px] rounded-full pointer-events-none" data-id="element-67"></div>

      <div className="max-w-4xl mx-auto relative z-10 flex flex-col items-center" data-id="element-68">
        <h2 className="font-playfair text-4xl md:text-5xl lg:text-6xl text-white leading-tight mb-16" data-id="element-69">
          "Tus ancestros sobrevivieron para que tú pudieras vivir."
        </h2>

        <a href="#pricing" className="inline-flex items-center justify-center px-10 py-5 bg-terracotta text-white font-medium text-lg rounded-full hover:bg-terracotta-hover transition-colors duration-300 shadow-lg shadow-terracotta/20" data-id="element-70">
          Quiero dejar de repetir esta historia →
        </a>
      </div>
    </section>;
}